/**
 * Señal de "listo para prerender" para @prerenderer/rollup-plugin.
 *
 * El renderer Puppeteer espera al evento `render-event` antes de capturar el
 * DOM (configurado en vite.config.js). Las vistas con fetch async (BlogPost,
 * BlogCategory, BlogIndex) deben llamar a `signalPrerenderReady()` tras cargar
 * sus datos, para garantizar que los meta tags reactivos (useSeo, useSchemaOrg)
 * estén aplicados antes del snapshot.
 *
 * Las vistas síncronas (servicios, páginas estáticas) NO necesitan llamarlo:
 * App.vue dispara la señal automáticamente tras router.isReady() + nextTick.
 *
 * No-op cuando window no existe (SSR / Node) o cuando ya se disparó.
 */

let alreadyDispatched = false

export function signalPrerenderReady() {
  if (typeof window === 'undefined' || alreadyDispatched) return
  alreadyDispatched = true
  document.dispatchEvent(new Event('render-event'))
}

export function resetPrerenderReady() {
  alreadyDispatched = false
}
